// HTTP wrapper for table maintenance (check / analyze / optimize / repair).
// Admin-only on the backend. Returns { columns, rows, sql } — the maintenance
// result set MySQL produces (Table, Op, Msg_type, Msg_text).
import { api } from './api.js';

export async function maintainTable(connectionId, database, table, op, options = []) {
  return api.post(
    `/api/connections/${connectionId}/databases/${encodeURIComponent(database)}/tables/${encodeURIComponent(table)}/maintain`,
    { op, options },
  );
}
